import Vue from "vue";
import Component from "vue-class-component";
import moment from "moment/moment";
import { Event, Collab } from "@/shared/Event";

@Component
export default class EventMixin extends Vue {
  public hierarchie: { [key: string]: any[] } = {};
  public DATE_FORMAT = "YYYY-MM-DD";

  public COLORS = {
    ca: "light-blue--text  text-darken-3",
    prevs: "pink--text text-lighten-1",
    caBack: "light-blue  darken-3",
    prevsBack: "pink lighten-1",
  };

  public transformHierarchie(prevhierarchie: Collab) {
    this.hierarchie = {};
    let perimplus = new Array();
    perimplus = prevhierarchie.perim_plus;
    this.orderHier(prevhierarchie);
    const hierarchie: { [key: string]: any[] } = {
      EVENEMENT: [],
      CANAL: [],
      PLU: [],
      EVENEMENTNAT: [],
    };

    perimplus.map((ev: any) => {
      if (ev.id_pluprev_parent === "") {
        const evtParent = {
          id: ev.id_pluprev,
          key: ev.id_pluprev + prevhierarchie.perim_plus.indexOf(ev),
          libelle: ev.designation_pluprev,
          liste: new Array(),
        };
        const mesenfants = this.findChidrenPlu(ev.id_pluprev, perimplus);
        evtParent.liste = mesenfants;
        hierarchie.PLU.push(evtParent);
      }
    });

    prevhierarchie.perim_canaux.map((ev: any) => {
      if (ev.id_canvente_parent === "") {
        const enfant = {
          id: ev.id_canvente,
          libelle: ev.designation_canvente,
          key: ev.id_canvente + prevhierarchie.perim_canaux.indexOf(ev),
          liste: new Array(),
        };
        enfant.liste = this.findChidrenCanal(ev.id_canvente, prevhierarchie);
        hierarchie.CANAL.push(enfant);
      }
    });
    prevhierarchie.param_hierarchies.map((ev: any) => {
      if (ev.attributSource === "LOC" && ev.id_hierarchie_parent === "") {
        hierarchie.EVENEMENT.push({
          id: ev.id_hierarchie,
          libelle: ev.designation_hierarchie,
          couleur: ev.attribut_fmcouleur,
          key: ev.id_hierarchie + prevhierarchie.param_hierarchies.indexOf(ev),
          liste: new Array(),
          typeImpactDefaut: ev.typeImpactDefaut,
        });
      } else if (ev.niveau === 3 && ev.attributSource === "LOC") {
        prevhierarchie.param_hierarchies.forEach((papaNiveau2: any) => {
          if (papaNiveau2.id_hierarchie === ev.id_hierarchie_parent) {
            hierarchie.EVENEMENT.forEach((papaNiveau1: any) => {
              if (
                papaNiveau2.id_hierarchie_parent === papaNiveau1.id &&
                papaNiveau2.id_hierarchie_parent.includes("LOCA")
              ) {
                papaNiveau1.liste.push({
                  id: ev.id_hierarchie,
                  libelle: ev.designation_hierarchie,
                  couleur: papaNiveau1.couleur,
                  key:
                    ev.id_hierarchie +
                    prevhierarchie.param_hierarchies.indexOf(ev),
                  typeImpactDefaut:
                    ev.typeImpactDefaut !== ""
                      ? ev.typeImpactDefaut
                      : papaNiveau1.typeImpactDefaut,
                });
              }
            });
          }
        });
      } else {
        hierarchie.EVENEMENTNAT.push(ev);
      }
    });
    return hierarchie;
  }

  public dateToArr(date: Date, isTimed?: boolean): number[] {
    let datestr = moment(date).format("YYYY,M,DD,HH,mm,ss,ms");
    if (!isTimed) {
      datestr = moment(date).format("YYYY,M,DD,00,00,00,00");
    }

    const dts = datestr.split(",");
    const dates = dts.map((d: string) => parseInt(d));
    return dates;
  }

  public getDate(nbr: number[]): Date {
    if (null === nbr || nbr.length < 1) {
      return new Date();
    }
    // console.log(nbr[1], moment().month((nbr[1] - 1)).format("MMMM"));
    const mo = moment()
      .year(nbr[0])
      .month(nbr[1] - 1)
      .date(nbr[2])
      .hour(nbr[3])
      .minute(nbr[4]);
    return mo.toDate();
  }

  public isFullDay(event: Event): boolean {
    if (event.date_debut[3] === 0 && event.date_fin[3] === 0) {
      event.$fullDay = true;
      return true;
    } else {
      event.$fullDay = false;
      return false;
    }
  }

  public translatepluCan(id: string, type: "PLU" | "CANAL" | "EVENEMENT") {
    // console.log(id, type);
    const m = this.hierarchie[type].filter((h: any) => h === id);
    if (m.length > 0) {
      return m[0].libelle;
    }
  }

  /**
   * methode de transformation de la fiab recue en fiab exploitable sur le calendrier
   */
  public transformFiabs(prevs: any) {
    if (prevs !== undefined) {
      // console.log(prevs);
      const keys = Object.keys(prevs);
      const myevents = new Array();
      const today = moment(new Date(), this.DATE_FORMAT);
      for (const prev of keys) {
        const date = moment(prev, this.DATE_FORMAT);
        /*if (date.isAfter(moment("01/04/2022", "DD/MM/YYYY")) &&
                date.isBefore(moment("01/09/2022", "DD/MM/YYYY"))) { */
        if (
          date.isAfter(today) ||
          date.format(this.DATE_FORMAT) === today.format(this.DATE_FORMAT)
        ) {
          const day = prevs[prev];
          const event = {
            name:
              Number(day.prevJ.toFixed(0)).toLocaleString(undefined, {
                minimumFractionDigits: 0,
              }) + " €",
            start: date.toDate(),
            end: date.toDate(),
            color: this.COLORS.prevs,
            timed: true,
            type: "prev",
            category: "prev",
            id: prev,
            index: 2,
          };
          myevents.push(event);
          // }
        }
      }
      return myevents;
    }
  }
  /**
   * Méthode permettant de transformet les CA par jour sur mois en évenement du calendrier
   * @param datas - Array - les Ca par jour sur mois
   */
  public decryptCA(datas: any, myevents: any[]) {
    const events = new Array();
    const keys = Object.keys(datas);
    for (const ev of keys) {
      if (!moment(ev).isAfter(moment())) {
        // console.log(ev, datas[ev].toFixed(0), moment(ev).toDate());
        const event = {
          name:
            Number(datas[ev].toFixed(0)).toLocaleString(undefined, {
              minimumFractionDigits: 0,
            }) + " €",
          start: moment(ev).toDate(),
          end: moment(ev).toDate(),
          color: this.COLORS.ca,
          class: "caEv",
          timed: true,
          index: 0,
          category: "ca",
          type: "ca",
          id: ev,
        };
        events.push(event);
      }
    }
    myevents = myevents.concat(events);
    return myevents;
  }
  /**
   * methode de transformation d'un evenement BK en evenement du calendrier
   * @param events Event[] - les evenements BK
   */
  public transformCalendarEvents(events: Event[], myEvents: any[]) {
    const myevents = new Array();
    for (const ev of events) {
      if (!ev.flag_suppression) {
        const exist = myevents.filter((calev: any) => calev.id === ev.uuid_evt);
        // console.log(exist);
        if (exist.length === 0) {
          const event = {
            name: ev.designation,
            start: this.getDate(ev.date_debut),
            end: this.getDate(ev.date_fin),
            color: ev.source === "NAT" ? ev.couleur : "#fdd835",
            timed: false,
            type: ev.source,
            category: "event",
            index: 9,
            id: ev.uuid_evt,
          };
          if (!event.color || event.color[0] !== "#") {
            event.color = "#0d47a1";
          }
          myevents.push(event);
        }
      }
    }
    myEvents = myEvents.concat(myevents);
    // console.log(myEvents);
    return myEvents;
  }
  /**
   * Méthode de réccurence pour bien affecter les plu à la hierarchie
   * @param idpapa
   * @param prevhierarchie
   * @returns
   */
  private findChidrenPlu(idpapa: string, perimplus: any) {
    const enfants = new Array();
    perimplus.forEach((ev: any) => {
      if (ev.id_pluprev_parent === idpapa) {
        const enfant: { [key: string]: any } = {
          id: ev.id_pluprev,
          key: ev.id_pluprev + perimplus.indexOf(ev),
          libelle: ev.designation_pluprev,
        };
        if (ev.niv_pluprev >= 4) {
          enfant.liste = new Array();
          const grandChild = this.findChidrenPlu(ev.id_pluprev, perimplus);
          // console.log(grandChild);
          enfant.liste = grandChild;
        }
        enfants.push(enfant);
      }
    });
    return enfants;
  }
  /**
   * Méthode de réccurence pour bien affecter les canaux de vente à la hierarchie
   * @param idpapa
   * @param prevhierarchie
   * @returns
   */
  private findChidrenCanal(idpapa: string, prevhierarchie: Collab) {
    const enfants = new Array();
    prevhierarchie.perim_canaux.forEach((ev: any) => {
      if (ev.id_canvente_parent === idpapa) {
        const enfant: { [key: string]: any } = {
          id: ev.id_canvente,
          libelle: ev.designation_canvente,
          key: ev.id_canvente + prevhierarchie.perim_canaux.indexOf(ev),
        };
        if (ev.niv_canvente >= 4) {
          enfant.liste = new Array();
          const grandChild = this.findChidrenCanal(
            ev.id_canvente,
            prevhierarchie
          );
          // console.log(grandChild);
          enfant.liste = grandChild;
        }
        enfants.push(enfant);
      }
    });
    return enfants;
  }
  /**
   * Méthode de réccurence pour bien affecter les type d'evenement à la hierarchie
   * @param idpapa
   * @param prevhierarchie
   * @returns
   */
  private orderHier(prevhierarchie: Collab) {
    prevhierarchie.perim_plus.sort((a: any, b: any) => {
      return a.niv_pluprev - b.niv_pluprev;
    });
    prevhierarchie.perim_canaux.sort((a: any, b: any) => {
      return a.niv_canvente - b.niv_pluprev;
    });

    prevhierarchie.param_hierarchies.sort((a: any, b: any) => {
      return a.niveau - b.niveau;
    });
  }
}
